var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncognito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1000 1000",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m837.2 689.4-130.2-130.1c10.2-25.4 16-52.6 16-81.6 0-123-99.9-222.8-222.9-222.8-29 0-56.1 5.8-81.5 16l-96.3-96.3c55.3-20 115-31.2 177.4-31.2 222.8 0 413.1 138.5 490.2 334.2-32.4 83-85.4 155.7-152.7 211.8zm-336.5-344.9c74 0 133.7 59.7 133.7 133.7l-.9 7.1-140.4-140.4zm344 578.9-130.6-130.2-18.7-18.7c-60.2 24.1-126.1 37.5-195.2 37.5-222.8 0-413.1-138.6-490.2-334.3 34.7-88.3 92.7-164.9 166.7-222.4l-20.6-20.5-101.5-101.6 56.6-56.6 790.2 790.1zm-315.5-315.6c-9.4 2.3-19.1 3.6-29 3.6-73.9 0-133.7-59.7-133.7-133.7 0-9.9 1.3-19.6 3.6-29l-69.1-69.1c-14.7 29.9-23.6 62.9-23.6 98.1 0 123 99.8 222.8 222.8 222.8 35.2 0 68.2-8.9 98.1-23.6z",
    fill: "#ae00ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncognito);
export default __webpack_public_path__ + "static/media/incognito.1be46e6821deff78511196dadca1a896.svg";
export { ForwardRef as ReactComponent };